import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/app/staff/settings")({ component: StaffSettingsRedirect });

function StaffSettingsRedirect() {
  const nav = useNavigate();

  useEffect(() => {
    nav({ to: "/app/settings", search: { tab: "system" } });
  }, [nav]);

  return null;
}
